import ContentLoader from 'react-content-loader';
import { EventItemLoading } from '../../molecules/EventItem/EventItemLoading';

interface iEventListLoadingProps {
  itemsCount: number;
}

function EventListLoading({ itemsCount }: iEventListLoadingProps) {
  return (
    <div>
      <ContentLoader viewBox={`0 0 400 ${itemsCount * 70}`}>
        {Array.from(Array(itemsCount).keys()).map((item) => (
          <EventItemLoading y={item * 70} key={item} />
        ))}
      </ContentLoader>
    </div>
  );
}

export { EventListLoading };
